import React, { useState, useCallback } from 'react';
import { animated } from '@react-spring/web';
import { constrain, isTouchDevice, mergeClassNames } from '../../utils';
import styles from './index.module.scss';

export default function ScrollProgress({ sections, selectHandler, className = null, style = null }) {
  const [active, setActive] = useState(false);

  const handleState = useCallback(
    event => {
      if (isTouchDevice()) {
        switch (event.type) {
          case 'mouseenter':
          case 'click':
            setActive(true);
            break;
          case 'mouseleave':
            setActive(false);
            break;
          default:
            break;
        }
      } else {
        // DESKTOP
        switch (event.type) {
          case 'mouseenter':
            setActive(true);
            break;
          case 'mouseleave':
            setActive(false);
            break;
          default:
            break;
        }
      }
    },
    [setActive]
  );

  const handleInteraction = useCallback(
    (event, index) => {
      if (!active) {
        return null;
      }
      if (isTouchDevice()) {
        switch (event.type) {
          case 'click':
            selectHandler(sections[index]);
            break;
          default:
            break;
        }
      } else {
        // DESKTOP
        switch (event.type) {
          case 'click':
            setActive(false);
            selectHandler(sections[index]);
            break;
          default:
            break;
        }
      }
    },
    [active, selectHandler, sections]
  );

  return (
    <div className={mergeClassNames(styles.scrollProgress, className)} style={style}>
      <nav
        className={mergeClassNames(styles.progression, active ? styles.active : '')}
        onMouseEnter={event => handleState(event)}
        onMouseLeave={event => handleState(event)}
      >
        <ul>
          {sections?.map((section, index) => {
            // let opacity = hoverIndex === -1 ? 0 : 1 - Math.abs((index - hoverIndex) / 3);

            let style = {
              opacity: active ? 1 : 1,
              // backgroundImage: active
              //   ? 'linear-gradient(90deg, #FFC0CB 10%, #00FFFF 10%)'
              //   : 'linear-gradient(90deg, red 90%, green 90%)',
              // backgroundSize: active ? '50% 100%' : '100% 100%',
            };

            return (
              <ProgressItem
                key={index}
                title={section.title}
                index={section.index}
                interactionHandler={handleInteraction}
                progressSpring={section.progressSpring}
                // section.style is used to override styling for individual elements. See Products on Devices
                style={{ ...style, ...section.style }}
                className={mergeClassNames(styles.button, active ? styles.active : null)}
              />
            );
          })}
        </ul>
      </nav>
    </div>
  );
}

function ProgressItem({ title, index, className = '', style, interactionHandler, progressSpring }) {
  return (
    <li className={styles.progressItem}>
      <Dash progressSpring={progressSpring} />
      <button onClick={event => interactionHandler(event, index)} className={className} style={style}>
        <div className={styles.buttonLabel}>{title}</div>
      </button>
    </li>
  );
}

function Dash({ progressSpring }) {
  return (
    <div className={styles.dash}>
      <animated.div
        className={styles.blue}
        style={{
          transform: progressSpring ? progressSpring.to(x => `scale(1, ${constrain(x, 0, 1)})`) : `scale(1, 0)`,
        }}
      />
    </div>
  );
}
